<label for="{{ labelControlName }}">
    {{ labelText | translate }}
    <span *ngIf="isRequired">*</span>
</label>
